import React from "react";
import phone from "../images/process-phone.png";
import loop from "../images/process-loop.png";
import email from "../images/process-email.png";
import ProcessCard from "../Cards/ProcessCard";

function Process() {
  const processes = [
    { title: "Zenhook92@gmail.com", img: email },
    { title: "+91 93636 52998", img: phone },
    { title: "64, Pettai Road, Dindigul-624002", img: loop },
  ];
  return (
    <div className="flex mt-16 mb-10 flex-wrap md:flex-nowrap md:gap-32 gap-16 ">
      {/* map the each value and render imag and title */}
      { processes.map((data, index ) => (
        <ProcessCard img={data.img} title={data.title} key={index} />
      ))}
    </div>
  );
}

export default Process;
